<mat-toolbar class="top-nav">
  <div class="top-nav__menu">
    <site-portal *ngIf="showSiteSelector"></site-portal>

    <button
      *ngIf="isQPUser"
      (click)="onViewInvitations()"
      mat-icon-button
      class="top-nav__menu-notifications"
      [class.top-nav__menu-notifications--active]="true"
    >
      <div class="ntftn-bell">
        <span class="ntfcn-cntr" *ngIf="(qpInvitationService.totalQPInvitations$ | async) > 0">
          {{ qpInvitationService.totalQPInvitations$ | async }}
        </span>
        <img src="assets/svg/icons/qa-invitation.svg" />
      </div>
    </button>
    <button
      (click)="onViewNotifications()"
      mat-icon-button
      class="top-nav__menu-notifications"
      [class.top-nav__menu-notifications--active]="true"
    >
      <div class="ntftn-bell">
        <span class="ntfcn-cntr" *ngIf="(notificationService.totalNewCount$ | async) > 0">
          {{ notificationService.totalNewCount$ | async }}
        </span>
        <img src="assets/svg/icons/top-bell.svg" />
      </div>
    </button>

    <user-menu></user-menu>
  </div>
</mat-toolbar>
